export const agentStudioRouteNames = {
    aiAgentsAgentStudio: 'ai-agents-agent-studio',
    aiAgentsAgentStudioDefault: 'ai-agents-agent-studio-default',
    agentStudioAgentVersionManager: 'agent-studio-agent-version-manager',
    agentStudioFlowEditor: 'agent-studio-flow-editor'
}

